import React from "react"
import { Link } from "gatsby"
import './styles.css'

const BusinessTitleCard = ({ icon, title, subtitle, link }) => {
  return (
    <Link to={link}>
      <div className="business-title_card d-flex align-center">
        <div className="business-icon-card">
          <img src={icon} alt={title} className="img-fluid" />
        </div>
        <div className="flex-column justify-content-start">
          <h4 className="sparkle-deep-blue">{title}</h4>
          <p>{subtitle}</p>
        </div>
      </div>
    </Link>
  )
}
export default BusinessTitleCard
